import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { filter, map, switchMap, take } from 'rxjs';
import { AuthService } from '../../shared/services/auth.service';
import { UserRole } from '../../shared/models/user.model';
import { getLandingRoute } from '../../shared/constants/role-access';

export const adminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // isAuthenticated$ is null until AuthService has resolved the token (validating it or
  // fetching /user/currentUser on a hard reload). Wait for that resolution before reading
  // currentUser$ — otherwise a still-null currentUser$ misroutes an actually-authenticated
  // ADMIN to their landing route.
  return authService.isAuthenticated$.pipe(
    filter(isAuthenticated => isAuthenticated !== null),
    take(1),
    switchMap(() => authService.currentUser$.pipe(take(1))),
    map((user) => {
      if (user?.role === UserRole.ADMIN) {
        return true;
      }
      router.navigate([getLandingRoute(user?.role)]);
      return false;
    })
  );
};
